<div class="delivery-countdown-timer-form-appearance">
  <div class="content">
    <div class="section">
      <pdq-heading element="h5">Appearance</pdq-heading>
      <div class="controls-wrapper" [formGroup]="appearanceGroup">
        <div class="field-group">
          <span class="field-label">Component placement</span>
          <pdq-radio-group [formControl]="appearanceGroup.get('componentPlacement')">
            <pdq-radio-button
              [value]="ComponentPlacement.STANDALONE"
              [checked]="appearanceGroup.get('componentPlacement')?.value === ComponentPlacement.STANDALONE"
              text="Standalone"></pdq-radio-button>
            <pdq-radio-button
              [value]="ComponentPlacement.INSIDE_SHIPPING_METHOD"
              [checked]="
                appearanceGroup.get('componentPlacement')?.value === ComponentPlacement.INSIDE_SHIPPING_METHOD
              ">
              <ng-template #customContent>
                <div class="linked-mode-radio-content">
                  <p class="linked-mode-radio-content__title caption-medium-caps">Inside shipping method</p>
                  <p class="linked-mode-radio-content__description body-12-regular">
                    Go to your
                    <pdq-link
                      [clickable]="true"
                      [external]="true"
                      size="small"
                      label="Online Store Editor"
                      [url]="shopService.ecommerceEditorUrl()"></pdq-link>
                    to define which shipping method this extension shows up for
                  </p>
                </div>
              </ng-template>
            </pdq-radio-button>
          </pdq-radio-group>
        </div>

        <div class="field-group">
          <span class="field-label">Background variant</span>
          <pdq-dropdown
            [formControl]="appearanceGroup.get('backgroundColor')"
            [options]="bannerVariantOptions"
            [fullWidth]="true"
            label="Select background variant"
            placeholder="Choose a variant"></pdq-dropdown>
        </div>

        <div class="field-group">
          <rich-text-editor
            label="Display text"
            [control]="appearanceGroup.get('displayText')"
            [placeholder]="'Order within {countdown} for delivery via {shipping_method}'"
            [invalidMsg]="
              appearanceGroup.get('displayText')?.hasError('required') && appearanceGroup.get('displayText')?.touched
                ? 'Field cannot be empty'
                : null
            "></rich-text-editor>
          <p class="help-text">
            Dynamic fields available. Type &#123; to see options.<br />
            Available tokens: &#123;countdown&#125;, &#123;shipping_method&#125;
          </p>
        </div>

        <div class="field-group">
          <span class="field-label">Timer format</span>
          <pdq-radio-group [formControl]="appearanceGroup.get('timerFormat')">
            <pdq-radio-button
              [value]="TimerFormat.DIGITAL"
              [checked]="appearanceGroup.get('timerFormat')?.value === TimerFormat.DIGITAL"
              text="Digital (01:30:45)"></pdq-radio-button>
            <pdq-radio-button
              [value]="TimerFormat.COMPACT"
              [checked]="appearanceGroup.get('timerFormat')?.value === TimerFormat.COMPACT"
              text="Compact (1Hr 30m)"></pdq-radio-button>
          </pdq-radio-group>
        </div>
      </div>
    </div>
  </div>
</div>
